export const submitCreateTaskForm = () => {
  const form = document.querySelector('.js-create-form');

  if (!form) return;

  const submitElements = form.querySelectorAll('button[type="submit"]');

  if (submitElements.length === 0) return;

  let isSent = false;

  const onSubmit = (event: Event) => {
    if (isSent) {
      event.preventDefault();
      return;
    }

    isSent = true;

    submitElements.forEach((submitElement) => {
      submitElement.classList.add("create__button--sent");
    });
  }

  form.addEventListener('submit', onSubmit);
}
